import {
  GlobalEvents,
  Theme
} from "./chunk-DNDL4K7L.js";
import "./chunk-RGTSXKO2.js";

// src/layout/theme/theme.ts
function initAddToCartLinks() {
  const allLinks = document.querySelectorAll('a[href^="#add-"]');
  allLinks.forEach((link) => {
    const href = link.getAttribute("href") || "";
    const regex = /^#add-(\d+)-([a-zA-Z0-9]+)$/;
    const match = href.match(regex);
    if (match) {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const quantity = parseInt(match[1], 10);
        const variantId = match[2];
        Theme.Cart.addItem({
          id: variantId,
          quantity
        }).then(
          () => {
            GlobalEvents.emit("cart:updated");
            GlobalEvents.emit("cart:open");
          }
        );
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.setAttribute("data-js", "true");
  initAddToCartLinks();
});
